/**
 * Get the parameters.
 * @param  {string} blockId the block id.
 */
export const getParams = (block) => {
	const urlParams = new URLSearchParams(window.location.search);
	const filterContainer = block.querySelector('.em-filterable-content__filter-container');
	const params = {};
	const { dataset } = filterContainer;

	urlParams.forEach((value, key) => {
		params[key] = value;
		if (key === 'paged') {
			filterContainer.dataset.paged = value;
		}
	});

	// Set default parameters from the block filter container.
	const defaultParams = {
		block: block.id,
		...dataset,
	};

	Object.keys(defaultParams).forEach((key) => {
		const value = defaultParams[key];
		if (params[key] !== value) {
			params[key] = value;
		} else {
			params[key] = defaultParams[key];
		}
	});

	return params;
};

export const setParams = (block, extraParams = {}) => {
	const filterContainer = block.querySelector('.em-filterable-content__filter-container');
	const inputs = block.querySelectorAll('[type="checkbox"], [name="search"], select');
	const params = {
		paged: filterContainer.dataset.paged,
		...extraParams,
	};

	// Loop through the inputs and get the set values.
	inputs.forEach((e) => {
		const {
			checked,
			classList,
			dataset,
			value,
			name,
		} = e;
		const { tax } = dataset;

		// If is checked set the tax parameters.
		if (checked && tax) {
			if (params[tax] !== undefined) {
				params[tax].push(value);
			} else {
				params[tax] = [value];
			}
		}

		// If is search set the search parameter.
		if (classList.contains('filter-search') && value) {
			params.search = value;
		}

		if (name === 'orderby' && value) {
			filterContainer.dataset.orderby = value;
			params.orderby = value;
		}
	});

	const query = new URLSearchParams(params).toString();
	let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
	if (query) {
		newUrl += `?${query}`;
	}
	window.history.pushState({ path: newUrl }, '', newUrl);
};
